import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import { getLocales } from 'assets/locales/Locale';
import { HttpStatus } from 'config/Api.Config';
import contractSaveUnrestrictedApi from 'models/sales/contract/saveUnrestricted/Api.Contract.SaveUnrestricted';
import { SalesContractAction, useSalesContractProvider } from '../../Sales.Contract.Hooks';
import ContractAdjustDistributionsDocuments from './tabs/Contract.AdjustDistributions.Documents';
import ContractAdjustDistributionsEnhancementsDistributions from './tabs/Contract.AdjustDistributions.EnhancementsDistributions';
import ContractAdjustDistributionsDistributions from './tabs/Contract.AdjustDistributions.Distributions';
import { isEmpty } from 'lodash';
import ContractAdjustDistributionsDates from './tabs/Contract.AdjustDistributions.Dates';
import ContractAdjustDistributionsSurcharges from './tabs/Contract.AdjustDistributions.Surcharges';

enum Tabs {
  distributions = 'distributions',
  enhancementsDistributions = 'enhancementsDistributions',
  documents = 'documents',
  dates = 'dates',
  surcharges = 'surcharges',
}
export type ContractAdjustForm = Partial<Model.IContract> & Api.Core.Contract.Save.IQuery;
export default function ContractAdjustDistributions() {
  const { lang } = getLocales();
  const { selected, findApi, listApi, pageRouter } = useSalesContractProvider();

  return (
    <ModalForm<ContractAdjustForm>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.editContractUnrestricted}
      default={{
        ...selected?.toJSON(),
        sendDocumentForSigning: false,
        generateDocuments: false,
        contractEnhancements: selected?.contractEnhancements ?? [],
        subfees: selected?.subfees ?? [],
      }}
      onCancel={() => pageRouter.updateParams({ id: selected.id.toString(), action: SalesContractAction.INFO })}
      onSubmit={async (data) => {
        const res = await contractSaveUnrestrictedApi(data, {
          sendDocumentForSigning: data.sendDocumentForSigning,
          generateDocuments: data.generateDocuments,
        });
        if (res.status !== HttpStatus.ok) addLog({ error: res.message });
        else {
          addLog({ success: lang.saveSuccess });
          pageRouter.updateParams({ id: selected.id.toString(), action: SalesContractAction.INFO });
          listApi.execute((body) => body);
          findApi.execute((body) => body);
        }
      }}
      tabs={[
        { id: Tabs.distributions, icon: 'fas-coins', text: lang.distributions },
        {
          id: Tabs.enhancementsDistributions,
          icon: 'fas-coins',
          text: lang.enhancementsDistributions,
          disabled: isEmpty(selected?.contractEnhancements),
        },
        {
          id: Tabs.surcharges,
          icon: 'fas-plus',
          text: lang.surcharges,
          disabled: isEmpty(selected?.subfees),
        },
        { id: Tabs.documents, icon: 'fas-folder', text: lang.documents },
        { id: Tabs.dates, icon: 'fas-calendar-alt', text: lang.dates },
      ]}
      render={({ activeTab }) =>
        activeTab?.id === Tabs.distributions ? (
          <ContractAdjustDistributionsDistributions />
        ) : activeTab?.id === Tabs.enhancementsDistributions ? (
          <ContractAdjustDistributionsEnhancementsDistributions />
        ) : activeTab?.id === Tabs.surcharges ? (
          <ContractAdjustDistributionsSurcharges />
        ) : activeTab?.id === Tabs.documents ? (
          <ContractAdjustDistributionsDocuments />
        ) : activeTab?.id === Tabs.dates ? (
          <ContractAdjustDistributionsDates />
        ) : null
      }
    />
  );
}
